import React from 'react';
import PropTypes from 'prop-types';

import styles from './NewTitle.less';
import userIntents from '../../../userIntents';

export default function NewTitle({ text, userIntent }) {
  const preTitleForSell = 'Immobilienpreise in ';
  const date = new Date();
  const afterTitleForSell = date.getFullYear().toString();

  const getPreTitle = () => {
    switch (userIntent) {
      case userIntents.BUY:
      case userIntents.SELL:
        return preTitleForSell;
      case userIntents.LET:
      case userIntents.RENT:
        return 'Mietpreise ';
      default:
        return '';
    }
  };

  return (
    <h1 id="header-headline" className={`${styles.headerTitle} ${styles.headerTitleText}`}>
      {getPreTitle()}
      {`${text}`}
      {` ${afterTitleForSell}`}
    </h1>
  );
}

NewTitle.defaultProps = {
  text: null,
  userIntent: null,
};

NewTitle.propTypes = {
  text: PropTypes.string,
  userIntent: PropTypes.string,
};
